import { Component } from '@angular/core';

@Component({
  selector: 'wk8-ceiling',
  imports: [],
  templateUrl: './wk8-ceiling.component.html',
  styleUrl: './wk8-ceiling.component.css',
})
export class Wk8CeilingComponent {}
